import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'app-progress-button',
  templateUrl: './progress-button.component.html',
  styleUrls: ['./progress-button.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProgressButtonComponent {
  @Input() label: string
  @Input() type: 'button' | 'submit' | 'reset' = 'button'
  @Input() loading = false
  @Input() disabled = false
  @Input() buttonClass = ''
  @Input() minWidth = 140
  @Input() spinnerDiameter = 18

  @Output() buttonClick = new EventEmitter<Event>()

  onClick(event: Event): void {
    if (this.disabled || this.loading) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return
    }
    this.buttonClick.emit(event)
  }
}
